<script>
    import {darkMode} from "./store.js"
</script>


<a class="btn m-1 py-1 px-2" href="https://github.com/Teyooooo/anime-manga-quiz" target="_blank">
    <img src="{$darkMode ? "res/github-mark-white.svg" : "res/github-mark.svg"}" alt="github redirect" width="28px">
</a>